import ApolloCustomTriggerItem from "../Domain/ApolloCustomTriggerItem.js";
import serviceHelper from "../Helpers/serviceHelper.js";
import AuthService from "./authService.js";
import SearchParams from "../Elements/SearchParams";
import ApolloCustomTriggerSearchParams from "../Contents/RoverImport/ApolloCustomTriggerAdmin/ApolloCustomTriggerSearchParams";

class ApolloCustomTriggerService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(searchItem, ApolloCustomTriggerSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/ApolloCustomTrigger/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new ApolloCustomTriggerItem(item));
    }

    return [];
  }

  static Edit(item) {
    let tempItem = { ...item };
    if (tempItem.UseQuestionIdAsEmailRecipient) tempItem.EmailRecipients = `{${tempItem.EmailRecipients}}`;
    if (tempItem.QuestionValueIsNotEmpty) tempItem.QuestionValue = "{NotEmpty}";
    tempItem = serviceHelper.ConvertAllPropertyToString(tempItem);
    const itemJSON = JSON.stringify(tempItem);

    return AuthService.getInstance().CallBackendFunctionPut("/api/ApolloCustomTrigger/Edit", itemJSON);
  }
}

export default ApolloCustomTriggerService;
